var BrowseContentHelper, DEAL_CONTENT_CONTAINER, DEAL_SPACE_MSG_CONTENT;

DEAL_CONTENT_CONTAINER = '#deal_content';

DEAL_SPACE_MSG_CONTENT = '#deal_space_message_content';

module.exports = BrowseContentHelper = {
  getDealsMessageSelector: function() {
    return $(DEAL_SPACE_MSG_CONTENT);
  },
  getDealsContentSelector: function() {
    return $(DEAL_CONTENT_CONTAINER);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL2NvbnRlbnQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL2NvbnRlbnQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQUE7O0FBQUEsc0JBQUEsR0FBeUI7O0FBQ3pCLHNCQUFBLEdBQXlCOztBQUV6QixNQUFNLENBQUMsT0FBUCxHQUFpQixtQkFBQSxHQUNmO0VBQUEsdUJBQUEsRUFBeUIsU0FBQTtXQUN2QixDQUFBLENBQUUsc0JBQUY7RUFEdUIsQ0FBekI7RUFHQSx1QkFBQSxFQUF5QixTQUFBO1dBQ3ZCLENBQUEsQ0FBRSxzQkFBRjtFQUR1QixDQUh6QiJ9
